/**
 * @file 产品使用场景概览产品卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback, useRef, useState} from 'react';
import {useLatest} from 'react-use';
import {Col} from 'antd';
import {ArrowRightOutlined} from '@ant-design/icons';
import A from '../../../../components/a/A';

interface IProductCardProps {
    zIndex?: number;
    title: string;
    text: string;
    extraText: string;
    url: string;
    target: boolean;
}

const ProductCard: React.FC<IProductCardProps> = props => {
    const extraRef = useRef<HTMLDivElement>(null);
    const [extraHeight, setExtraHeight] = useState<undefined | string | number>();
    const hoverStateRef = useRef<boolean>(false);
    const extraTextRef = useLatest(props.extraText);

    const mouseEnterHandle = useCallback(() => {
        if (extraRef.current && extraTextRef.current) {
            hoverStateRef.current = true;
            const height = extraRef.current.offsetHeight;
            setExtraHeight(height);
        }
    }, [setExtraHeight, extraTextRef]);
    const mouseLeaveHandle = useCallback(() => {
        if (extraRef.current) {
            hoverStateRef.current = false;
            const height = extraRef.current.offsetHeight;
            setExtraHeight((oldHeigt) => {
                if (typeof (oldHeigt) !== 'number') {
                    return height;
                }
                return oldHeigt;
            });
            setTimeout(() => {
                setExtraHeight(0);
            });
        }
    }, [setExtraHeight]);

    return (
        <Col
            className="paddle-psp-step-product-item-grid"
            xs={8}
            onMouseEnter={mouseEnterHandle}
            onMouseLeave={mouseLeaveHandle}
        >
            <A
                href={props.url}
                target={props.target ? '_blank' : undefined}
                rel={props.target ? 'noopener noreferrer' : undefined}
            >
                <div className="paddle-psp-step-product-item" style={{zIndex: props.zIndex}}>
                    <div
                        className="paddle-psp-step-product-item-title"
                    >
                        {props.title} {!!props.url && <ArrowRightOutlined />}
                    </div>
                    <div
                        className="paddle-psp-step-product-item-text"
                        dangerouslySetInnerHTML={{__html: props.text}}
                    />
                    <div
                        className="paddle-psp-step-product-item-extratext-wrap"
                        style={{height: extraHeight}}
                    >
                        <div
                            className="paddle-psp-step-product-item-extratext"
                            dangerouslySetInnerHTML={{__html: props.extraText}}
                            ref={extraRef}
                        />
                    </div>
                </div>
            </A>
        </Col>
    );
};

export default ProductCard;
